var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.loading
        ? _c("div", { staticClass: "loading" }, [
            _c(
              "div",
              { staticClass: "md-layout md-gutter md-alignment-top-center" },
              [
                _c("md-progress-spinner", {
                  attrs: {
                    "md-diameter": 50,
                    "md-stroke": 5,
                    "md-mode": "indeterminate"
                  }
                })
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.businessmodels
        ? _c(
            "div",
            { staticClass: "md-layout md-gutter md-alignment-top-center" },
            [
              _c(
                "div",
                {
                  staticClass:
                    "md-layout-item md-size-10 md-medium-size-10 md-small-size-10 md-xsmall-size-0"
                },
                [
                  _c(
                    "md-button",
                    {
                      staticClass: "md-fab",
                      on: {
                        click: function($event) {
                          return _vm.goBack()
                        }
                      }
                    },
                    [_c("md-icon", [_vm._v("arrow_back")])],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "md-layout-item md-size-75 md-medium-size-70 md-small-size-100 md-xsmall-size-100"
                },
                [
                  _c(
                    "div",
                    [
                      _c(
                        "md-table",
                        {
                          attrs: {
                            "md-sort": "name",
                            "md-sort-order": "asc",
                            "md-card": "",
                            "md-fixed-header": ""
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "md-table-row",
                                fn: function(ref) {
                                  var item = ref.item
                                  return _c(
                                    "md-table-row",
                                    {},
                                    [
                                      _c(
                                        "md-table-cell",
                                        {
                                          attrs: {
                                            "md-label": "Name",
                                            "md-sort-by": "name"
                                          }
                                        },
                                        [_vm._v(_vm._s(item.name))]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "md-table-cell",
                                        {
                                          attrs: {
                                            "md-label": "Datum",
                                            "md-sort-by": "date"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              new Date(
                                                item.timestamp
                                              ).toLocaleDateString("de-DE", {
                                                weekday: "long",
                                                year: "numeric",
                                                month: "long",
                                                day: "numeric"
                                              })
                                            )
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "md-table-cell",
                                        {
                                          attrs: {
                                            "md-label": "Speicherkommentar",
                                            "md-sort-by": "note"
                                          }
                                        },
                                        [_vm._v(_vm._s(item.note))]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "md-table-cell",
                                        { attrs: { "md-label": "Aktionen" } },
                                        [
                                          _c(
                                            "md-button",
                                            {
                                              staticClass: "md-icon-button",
                                              on: {
                                                click: function($event) {
                                                  _vm.deleteActive = true
                                                  _vm.modeltodelete = item.hash
                                                }
                                              }
                                            },
                                            [_c("md-icon", [_vm._v("delete")])],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "router-link",
                                            {
                                              attrs: {
                                                to: {
                                                  name: "BusinessModel",
                                                  params: {
                                                    bmname: item.name,
                                                    hash: item.hash
                                                  }
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "md-button",
                                                {
                                                  staticClass: "md-icon-button"
                                                },
                                                [
                                                  _c("md-icon", [
                                                    _vm._v("edit")
                                                  ])
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "md-button",
                                            {
                                              staticClass: "md-icon-button",
                                              on: {
                                                click: function($event) {
                                                  return _vm.loadRecommendations(
                                                    item.hash
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "md-icon",
                                                { staticClass: "mirror" },
                                                [_vm._v("wb_incandescent")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "md-tooltip",
                                                {
                                                  attrs: {
                                                    "md-direction": "right"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "Empfehlungen anzeigen"
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                }
                              }
                            ],
                            null,
                            false,
                            266127259
                          ),
                          model: {
                            value: _vm.businessmodels,
                            callback: function($$v) {
                              _vm.businessmodels = $$v
                            },
                            expression: "businessmodels"
                          }
                        },
                        [
                          _c("md-table-toolbar", [
                            _c("h1", { staticClass: "md-title" }, [
                              _vm._v("Geschäftsmodelle")
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "md-table-empty-state",
                            {
                              attrs: {
                                "md-label": "Kein Geschäftsmodell vorhanden.",
                                "md-description":
                                  "Sie haben bisher noch kein Geschäftsmodell angelegt"
                              }
                            },
                            [
                              _c(
                                "md-button",
                                {
                                  staticClass: "md-primary md-raised",
                                  on: {
                                    click: function($event) {
                                      _vm.nameActive = true
                                    }
                                  }
                                },
                                [_vm._v("Neues Geschäftsmodell erstellen")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c("div", {
                staticClass:
                  "md-layout-item md-size-15 md-medium-size-20 md-small-size-20 md-xsmall-size-40"
              })
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "md-layout md-gutter md-alignment-top-center" }),
      _vm._v(" "),
      _c(
        "md-dialog",
        {
          attrs: { "md-active": _vm.setRecommendationsActive },
          on: {
            "update:mdActive": function($event) {
              _vm.setRecommendationsActive = $event
            },
            "update:md-active": function($event) {
              _vm.setRecommendationsActive = $event
            }
          }
        },
        [
          _c("md-dialog-content", [
            _c(
              "div",
              { staticStyle: { padding: "10px" } },
              [
                _c("h1", [_vm._v("Technologieempfehlungen")]),
                _vm._v(" "),
                _c("h1", [_vm._v("für Ihr Geschäftsmodell")]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "md-layout md-gutter md-alignment-top-center"
                  },
                  [
                    _vm._l(_vm.recommendations, function(item) {
                      return _c(
                        "div",
                        {
                          key: item.hash,
                          staticClass:
                            "md-layout-item md-size-100 md-medium-size-100 md-small-size-100 md-xsmall-size-100",
                          staticStyle: { "margin-top": "10px" }
                        },
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "no-link",
                              attrs: {
                                to: {
                                  name: "TechnologyDetail",
                                  params: { hash: item.hash }
                                }
                              }
                            },
                            [
                              _c(
                                "md-card",
                                {
                                  staticClass:
                                    "margin-twenty md-alignment-top-center md-elevation-1",
                                  attrs: { "md-with-hover": "" }
                                },
                                [
                                  _c(
                                    "md-card-header",
                                    { staticClass: "md-title" },
                                    [
                                      _c("md-card-header-text", [
                                        _vm._v(_vm._s(item.name))
                                      ]),
                                      _vm._v(" "),
                                      _c("md-card-media", [
                                        item.image != "undefined"
                                          ? _c("img", {
                                              attrs: {
                                                "item.image": "",
                                                src:
                                                  "/static/uploads/" +
                                                  item.image
                                              }
                                            })
                                          : _vm._e()
                                      ])
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("md-card-content", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.shorten(item.description)
                                      )
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    }),
                    _vm._v(" "),
                    _vm.recommendations.length == 0
                      ? _c("div", [
                          _vm._v(
                            "\n            Aktuell gibt es zu diesem Geschäftsmodell keine Empfehlungen.\n          "
                          )
                        ])
                      : _vm._e()
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "md-dialog-actions",
                  [
                    _c(
                      "md-button",
                      {
                        staticClass: "md-primary",
                        on: {
                          click: function($event) {
                            _vm.setRecommendationsActive = false
                          }
                        }
                      },
                      [_vm._v("Schließen")]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "md-dialog",
        {
          attrs: { "md-active": _vm.deleteActive },
          on: {
            "update:mdActive": function($event) {
              _vm.deleteActive = $event
            },
            "update:md-active": function($event) {
              _vm.deleteActive = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticStyle: { padding: "10px" } },
            [
              _c("md-dialog-title", [
                _c("strong", [_vm._v("Geschäftsmodell löschen")])
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Wollen Sie Ihr konfiguriertes Geschäftsmodell wirklich löschen?"
                )
              ]),
              _vm._v(" "),
              _c(
                "md-dialog-actions",
                [
                  _c(
                    "md-button",
                    {
                      staticClass: "md-secondary",
                      on: {
                        click: function($event) {
                          _vm.deleteActive = false
                        }
                      }
                    },
                    [_vm._v("Abbrechen")]
                  ),
                  _vm._v(" "),
                  _c(
                    "md-button",
                    {
                      staticClass: "md-primary",
                      on: {
                        click: function($event) {
                          _vm.deleteActive = false
                          _vm.deleteBm()
                        }
                      }
                    },
                    [_vm._v("Löschen")]
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "md-dialog",
        {
          attrs: { "md-active": _vm.nameActive },
          on: {
            "update:mdActive": function($event) {
              _vm.nameActive = $event
            },
            "update:md-active": function($event) {
              _vm.nameActive = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticStyle: { padding: "10px" } },
            [
              _c("md-dialog-title", [_vm._v("Name für das Geschäftsmodell")]),
              _vm._v(" "),
              _c(
                "md-field",
                [
                  _c("label", { attrs: { for: "name" } }, [_vm._v("Name")]),
                  _vm._v(" "),
                  _c("md-input", {
                    attrs: { name: "name", id: "name" },
                    model: {
                      value: _vm.nameValue,
                      callback: function($$v) {
                        _vm.nameValue = $$v
                      },
                      expression: "nameValue"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "md-dialog-actions",
                [
                  _c(
                    "md-button",
                    {
                      staticClass: "md-primary",
                      on: {
                        click: function($event) {
                          _vm.createNew()
                          _vm.nameActive = false
                        }
                      }
                    },
                    [_vm._v("Fertig")]
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a0a9f0fc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a0a9f0fc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/company/businessmodel/load/BMLoad.vue
// module id = null
// module chunks = 